import React from 'react'
import { Checkbox } from 'antd'
import dayjs from 'dayjs'

// Custom columns for treatment plan visits
export const treatmentVisitsColumns = [
  {
    title: 'Specialist',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Status',
    dataIndex: 'compliant',
    key: 'compliant',
    render: (text, record) => (
      <>
        <Checkbox checked={record.compliant} />
        <small>
          {record.dateConfirmedCompliant ? (
            <span> - {dayjs(record.dateConfirmedCompliant).format('DD MMM YYYY')}</span>
          ) : (
            ''
          )}
        </small>
      </>
    )
  },
  {
    title: 'Next Visit',
    dataIndex: 'nextVisitDate',
    key: 'nextVisitDate',
    render: (text, record) => {
      return record.nextVisitDate ? dayjs(record.nextVisitDate).format('DD MMM YYYY') : 'Not scheduled'
    }
  }
]

// Custom columns for treatment plan trackers
export const treatmentTrackersColumns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: 'Medication',
    dataIndex: 'medication',
    key: 'medication'
  },
  {
    title: 'Dosage',
    dataIndex: 'dosage',
    key: 'dosage'
  },
  {
    title: 'Frequency',
    dataIndex: 'frequency',
    key: 'frequency'
  },
  {
    title: 'Notes',
    dataIndex: 'notes',
    key: 'notes'
  }
]

// Sample data for treatment plans
export const sampleTreatmentData = {
  medicationData: [
    {
      date: dayjs().subtract(1, 'day').format('DD MMM YYYY'),
      medication: 'Amoxicillin',
      dosage: '500mg',
      frequency: 'Twice daily',
      notes: 'Take with food'
    },
    {
      date: dayjs().subtract(1, 'day').format('DD MMM YYYY'),
      medication: 'Ibuprofen',
      dosage: '400mg',
      frequency: 'As needed',
      notes: 'For pain management'
    },
    {
      date: dayjs().subtract(5, 'days').format('DD MMM YYYY'),
      medication: 'Antibiotics',
      dosage: '250mg',
      frequency: 'Three times daily',
      notes: 'Complete full course'
    }
  ],
  specialistVisits: [
    {
      name: 'Primary Care Physician',
      compliant: true,
      dateConfirmedCompliant: dayjs().subtract(7, 'days').toISOString(),
      nextVisitDate: dayjs().add(30, 'days').toISOString()
    },
    {
      name: 'Orthopedic Specialist',
      compliant: true,
      dateConfirmedCompliant: dayjs().subtract(2, 'days').toISOString(),
      nextVisitDate: dayjs().add(14, 'days').toISOString()
    },
    {
      name: 'Physical Therapist',
      compliant: false,
      dateConfirmedCompliant: null,
      nextVisitDate: dayjs().add(7, 'days').toISOString()
    }
  ]
}
